module.exports = __webpack_public_path__ + "img/D201906_2.79f92376.jpg";